export enum ResponseCasingEnum {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Default,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CamelCase,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PascalCase,
}
